const defaultTitle = () => {
    document.title = 'Control Center';
}

const updateTitle = (value) => {
    document.title = `${value}`;
}

export { defaultTitle, updateTitle };
